// Import Constants
import { PageValidationTypes } from 'constants/common';
// Import Validation Scenarios
import { dynamicSegmentValidationScenario } from './dynamicSegment.scenario';
import { staticSegmentValidationScenario } from './staticSegment.scenario';
import { nonCustomerSegmentValidationScenario } from './nonCustomerSegment.scenario';
import { smsTemplateValidationScenario, smsTemplateScenarioPropertiesCreator } from './smsTemplate.scenario';
import { hooryTemplateValidationScenario, hooryTemplateScenarioPropertiesCreator } from './hooryTemplate.scenario';
import { compositeSegmentValidationScenario } from './compositeSegment.scenario';
import { reportValidationScenario } from './report.scenario';
import { compositeReportValidationScenario } from './compositeReport.scenario';
import { customerJourneyReportValidationScenario } from './customerJourneyReport.scenario';
import {
    telegramTemplateValidationScenario,
    telegramTemplateScenarioPropertiesCreater,
} from './telegramTemplate.scenario';
import {
    internalMessageTemplateValidationScenario,
    internalMessageTemplateScenarioProperiesCreater,
} from './internalMessageTemplate.scenario';
import {
    pushNotificationTemplateScenarioPropertiesCreater,
    pushNotificationTemplateValidationScenario,
} from './pushNotificationTemplate.scenario';
import {
    popUpNotificationTemplateScenarioPropertiesCreator,
    popUpNotificationTemplateValidationScenario,
} from './popUpNotificationTemplate.scenario';
import { cmsPopUpNotificationTemplateValidationScenario } from './cmsPopUpNotificationTemplate.scenario';
import { cmsBannerTemplateValidationScenario } from './cmsBannerTemplate.scenario';
import {
    reportExecuteScheduleValidationScenario,
    reportExecuteScheduleValidationCreate,
} from './reportExecuteSchedule.scenario';

import { emailTemplateValidationScenario, emailTemplateScenarioPropertiesCreator } from './emailTemplate.scenario';

import {
    campaignValidationScenario,
    bonusCalculationScenarioPropertiesCreator,
    campaignValidationScenario2,
} from './campaign.scenario';
import {
    customerJourneyValidationScenario,
    customerJourneyScenarioPropertiesCreator,
} from './customerJourney.scenario';
import { viberTemplateValidationScenario, viberTemplateScenarioPropertiesCreator } from './viberTemplate.scenario';
import {
    dynamicPopUpTemplateScenarioPropertiesCreator,
    dynamicPopUpTemplateValidationScenario,
} from './dynamicPopUpTemplate.scenario';
import {
    whatsAppTemplateScenarioPropertiesCreator,
    whatsAppTemplateValidationScenario,
} from './whatsAppTemplate.scenario';
import {
    whatsAppProviderTemplateScenarioPropertiesCreator,
    whatsAppProviderTemplateValidationScenario,
} from './whatsAppProviderTemplate.scenario';
import { formulaFilterValidationScenario } from './formulaFilter.scenario';
import { achievementValidationScenario } from './achievement.scenario';
import { knowledgeCenterArticleValidationScenario } from './knowledgeCenterArticle.scenario';

const {
    DynamicSegmentPage,
    StaticSegmentPage,
    SMSTemplatePage,
    HooryTemplatePage,
    TelegramTemplatePage,
    InternalMessageTemplatePage,
    EmailTemplatePage,
    DynamicPopUpTemplatePage,
    CompositeSegmentPage,
    CampaignPage,
    CampaignPageStepper,
    NonCustomerSegmentPage,
    JourneyPage,
    ReportPage,
    PushNotificationTemplatePage,
    PopUpNotificationTemplatePage,
    CMSPopUpNotificationTemplatePage,
    CMSBannerTemplatePage,
    ReportExecuteSchedulePage,
    CompositeReportPage,
    CustomerJourneyReportPage,
    ViberTemplatePage,
    WhatsAppTemplatePage,
    WhatsAppProviderTemplatePage,
    ExclusionRulesPage,
    FormulaFilterPage,
    AchievementPage,
    KnowledgeCenterArticlePage,
} = PageValidationTypes;

export default {
    [DynamicSegmentPage]: { scenario: dynamicSegmentValidationScenario },
    [StaticSegmentPage]: { scenario: staticSegmentValidationScenario },
    [SMSTemplatePage]: {
        scenario: smsTemplateValidationScenario,
        propertiesCreator: smsTemplateScenarioPropertiesCreator,
    },
    [HooryTemplatePage]: {
        scenario: hooryTemplateValidationScenario,
        propertiesCreator: hooryTemplateScenarioPropertiesCreator,
    },
    [TelegramTemplatePage]: {
        scenario: telegramTemplateValidationScenario,
        propertiesCreator: telegramTemplateScenarioPropertiesCreater,
    },
    [InternalMessageTemplatePage]: {
        scenario: internalMessageTemplateValidationScenario,
        propertiesCreator: internalMessageTemplateScenarioProperiesCreater,
    },
    [EmailTemplatePage]: {
        scenario: emailTemplateValidationScenario,
        propertiesCreator: emailTemplateScenarioPropertiesCreator,
    },
    [DynamicPopUpTemplatePage]: {
        scenario: dynamicPopUpTemplateValidationScenario,
        propertiesCreator: dynamicPopUpTemplateScenarioPropertiesCreator,
    },
    [CompositeSegmentPage]: { scenario: compositeSegmentValidationScenario },
    [CampaignPage]: {
        scenario: campaignValidationScenario,
        propertiesCreator: bonusCalculationScenarioPropertiesCreator,
    },
    [CampaignPageStepper]: {
        scenario: campaignValidationScenario2,
        propertiesCreator: bonusCalculationScenarioPropertiesCreator,
    },
    [NonCustomerSegmentPage]: { scenario: nonCustomerSegmentValidationScenario },
    [JourneyPage]: {
        scenario: customerJourneyValidationScenario,
        propertiesCreator: customerJourneyScenarioPropertiesCreator,
    },
    [ReportPage]: { scenario: reportValidationScenario },
    [PushNotificationTemplatePage]: {
        scenario: pushNotificationTemplateValidationScenario,
        propertiesCreator: pushNotificationTemplateScenarioPropertiesCreater,
    },
    [PopUpNotificationTemplatePage]: {
        scenario: popUpNotificationTemplateValidationScenario,
        propertiesCreator: popUpNotificationTemplateScenarioPropertiesCreator,
    },
    [CMSPopUpNotificationTemplatePage]: {
        scenario: cmsPopUpNotificationTemplateValidationScenario,
    },
    [CMSBannerTemplatePage]: {
        scenario: cmsBannerTemplateValidationScenario,
    },
    [ReportExecuteSchedulePage]: {
        scenario: reportExecuteScheduleValidationScenario,
        propertiesCreator: reportExecuteScheduleValidationCreate,
    },
    [CompositeReportPage]: { scenario: compositeReportValidationScenario },
    [CustomerJourneyReportPage]: { scenario: customerJourneyReportValidationScenario },
    [ViberTemplatePage]: {
        scenario: viberTemplateValidationScenario,
        propertiesCreator: viberTemplateScenarioPropertiesCreator,
    },
    [WhatsAppTemplatePage]: {
        scenario: whatsAppTemplateValidationScenario,
        propertiesCreator: whatsAppTemplateScenarioPropertiesCreator,
    },
    [WhatsAppProviderTemplatePage]: {
        scenario: whatsAppProviderTemplateValidationScenario,
        propertiesCreator: whatsAppProviderTemplateScenarioPropertiesCreator,
    },
    [ExclusionRulesPage]: {
        scenario: dynamicSegmentValidationScenario,
    },
    [FormulaFilterPage]: {
        scenario: formulaFilterValidationScenario,
    },
    [AchievementPage]: {
        scenario: achievementValidationScenario,
    },
    [KnowledgeCenterArticlePage]: {
        scenario: knowledgeCenterArticleValidationScenario,
    },
};
